import { createSvgIcon } from '@mui/material/utils'

// TODO With access to svgr, this can be done via:
//
//    // src/lib/createCustomSvgIcon.tsx
//    import React from 'react'
//    import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
//
//    export type CustomSvgIconProps = Omit<SvgIconProps, 'component'>
//
//    export default function createCustomSvgIcon(
//      component: SvgIconProps['component'],
//    ) {
//      return (props: CustomSvgIconProps) => (
//        <SvgIcon {...props} component={component} />
//      )
//    }
//
//    // src/automations/AutomationIcon.ts
//    // Clean up the svg first:
//    // - run through svgo
//    // - make sure there's no "fill" attributes set in the .svg
//    import createCustomSvgIcon from '@src/lib/createCustomSvgIcon'
//    import ReactComponent from './AutomationIcon.svg?react'
//    export default createCustomSvgIcon(ReactComponent)

export default createSvgIcon(
  <path
    d="M16.826 14.008l1.49 1.173c.183.134.231.374.116.585l-1.843 3.187c-.116.212-.356.288-.567.212l-2.294-.922c-.47.365-.989.672-1.555.902l-.346 2.439a.448.448 0 01-.451.393H7.689a.472.472 0 01-.46-.393l-.346-2.439a6.782 6.782 0 01-1.555-.902l-2.295.922a.469.469 0 01-.566-.212L.624 15.766a.471.471 0 01.115-.585l1.949-1.517a5.627 5.627 0 01-.067-.903c0-.297.038-.614.086-.902L.758 10.342c-.192-.134-.23-.384-.115-.585l1.834-3.188a.458.458 0 01.566-.21l2.294.92c.47-.354.99-.671 1.556-.902l.345-2.438a.455.455 0 01.451-.394h1.645A6.998 6.998 0 0115.323.17c3.864 0 7 3.136 7 7a7.006 7.006 0 01-5.497 6.838zM8.689 9.41a3.47 3.47 0 00-2.612 3.351c0 1.901 1.555 3.456 3.456 3.456a3.47 3.47 0 003.32-2.495A7.025 7.025 0 018.688 9.41zm6.634 2.76c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm.5-9v4.25l2.87 1.68-.75 1.23-3.62-2.16v-5h1.5z"
    fillRule="evenodd"
  />,
  'AutomationIcon',
)
